import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

// import UserEdit from './views/UserEdit.vue';


Vue.use(Router);


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [
    {
      path: '/emptypage',
      name: 'emptypage',
      component: require('@/views/EmptyPage').default
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },


    // companies / company
    // {
    //   path: '/companies',
    //   name: 'companies',
    //   component: () => import('./views/Companies.vue'),
    // },
    // {
    //   path: '/company/:id',
    //   name: 'company',
    //   props: true,
    //   component: () => import('./views/Company.vue'),
    // },
    // {
    //   path: '/company/',
    //   name: 'company',
    //   props: true,
    //   component: () => import('./views/Company.vue'),
    // },
    // {
    //   path: '/user2company/',
    //   name: 'user2company',
    //   props: true,
    //   component: () => import('./views/User2company.vue'),
    // },
    // {
    //   path: '/user2role/',
    //   name: 'user2role',
    //   props: true,
    //   component: () => import('./views/User2role.vue'),
    // },
    // {
    //   path: '/user2role/:id',
    //   name: 'user2role',
    //   props: true,
    //   component: () => import('./views/User2role.vue'),
    // },
    //
    // {
    //   path: '/company2modul/',
    //   name: 'company2modul',
    //   props: true,
    //   component: () => import('./views/Company2modul.vue'),
    // },
    //


    // {
    //   path: '/settings',
    //   name: 'settings',
    //   component: () => import('./views/Settings.vue'),
    // },

    // {
    //   path: '/invoiceinbounds',
    //   name: 'invoiceinbounds',
    //   component: () => import('./views/InvoiceInbounds.vue'),
    // },
    // {
    //   path: '/transferlist',
    //   name: 'transferlist',
    //   component: () => import('./views/TransferList.vue'),
    // },
    // {
    //   path: '/sbinvoiceinbounds',
    //   name: 'sbinvoiceinbounds',
    //   component: () => import('./views/SbInvoiceInbounds.vue'),
    // },
    // {
    //   path: '/sbinvoiceinbound/',
    //   name: 'sbinvoiceinbound',
    //   props: true,
    //   component: () => import('./views/SbInvoiceInbound.vue'),
    // },
    // {
    //   path: '/sbinvoiceinbound/:id',
    //   name: 'sbinvoiceinbound',
    //   props: true,
    //   component: () => import('./views/SbInvoiceInbound.vue'),
    // },
    // {
    //   path: '/invoiceoutbounds',
    //   name: 'invoiceoutbounds',
    //   props: true,
    //   component: () => import('./views/InvoiceOutbounds.vue'),
    // },
    // {
    //   path: '/invoiceoutboundnavrefresh',
    //   name: 'invoiceoutboundnavrefresh',
    //   props: true,
    //   component: () => import('./views/InvoiceOutboundNAVRefresh.vue'),
    // },
    //
    // {
    //   path: '/invoiceinboundsuploader',
    //   name: 'invoiceinboundsuploader',
    //   component: () => import('./views/InvoiceInboundsUploader.vue'),
    // },
    // {
    //   path: '/invoiceinboundsleader',
    //   name: 'invoiceinboundsleader',
    //   component: () => import('./views/InvoiceInboundsLeader.vue'),
    // },
    // {
    //   path: '/invoiceinboundsfinance',
    //   name: 'invoiceinboundsfinance',
    //   component: () => import('./views/InvoiceInboundsFinance.vue'),
    // },
    // {
    //   path: '/invoiceinboundsaccountant',
    //   name: 'invoiceinboundsaccountant',
    //   component: () => import('./views/InvoiceInboundsAccountant.vue'),
    // },
    // {
    //   path: '/invoiceinbound/:id',
    //   name: 'invoiceinbound',
    //   props: true,
    //   component: () => import('./views/InvoiceInbound.vue'),
    // },
    // {
    //   path: '/invoiceinboundnavrefresh/',
    //   name: 'invoiceinboundnavrefresh',
    //   props: true,
    //   component: () => import('./views/InvoiceInboundNAVRefresh.vue'),
    // },
    //
    // {
    //   path: '/otherincomeexpenses',
    //   name: 'otherincomeexpenses',
    //   component: () => import('./views/OtherIncomeExpenses.vue'),
    // },
    // {
    //   path: '/otherincomeexpense/:id',
    //   name: 'otherincomeexpense',
    //   props: true,
    //   component: () => import('./views/OtherIncomeExpense.vue'),
    // },
    // {
    //   path: '/otherincomeexpense',
    //   name: 'otherincomeexpense',
    //   props: true,
    //   component: () => import('./views/OtherIncomeExpense.vue'),
    // },
    // {
    //   path: '/incomeexpensestatement',
    //   name: 'incomeexpensestatement',
    //   props: true,
    //   component: () => import('./views/IncomeExpenseStatement.vue'),
    // },
    // {
    //   path: '/companydata',
    //   name: 'companydata',
    //   props: true,
    //   component: () => import('./views/CompanyData.vue'),
    // },
    //
    // {
    //   path: '/vats',
    //   name: 'vats',
    //   component: () => import('./views/Vats.vue'),
    // },
    // {
    //   path: '/vat/:id',
    //   name: 'vat',
    //   props: true,
    //   component: () => import('./views/Vat.vue'),
    // },
    // {
    //   path: '/vat',
    //   name: 'vat',
    //   props: true,
    //   component: () => import('./views/Vat.vue'),
    // },
    //
    // {
    //   path: '/proformas',
    //   name: 'proformas',
    //   component: () => import('./views/Proformas.vue'),
    // },
    // {
    //   path: '/proforma/:id',
    //   name: 'proforma',
    //   props: true,
    //   component: () => import('./views/Proforma.vue'),
    // },
    // {
    //   path: '/proforma',
    //   name: 'proforma',
    //   props: true,
    //   component: () => import('./views/Proforma.vue'),
    // },
    // {
    //   path: '/contracts',
    //   name: 'contracts',
    //   component: () => import('./views/Contracts.vue'),
    // },
    // {
    //   path: '/contract/:id',
    //   name: 'contract',
    //   props: true,
    //   component: () => import('./views/Contract.vue'),
    // },
    // {
    //   path: '/contract',
    //   name: 'contract',
    //   props: true,
    //   component: () => import('./views/Contract.vue'),
    // },
    //
    // {
    //   path: '/businesspartners',
    //   name: 'businesspartner',
    //   component: () => import('./views/BusinessPartners.vue'),
    // },
    // {
    //   path: '/businesspartner/:id',
    //   name: 'businesspartner',
    //   component: () => import('./views/BusinessPartner.vue'),
    // },
    // {
    //   path: '/businesspartner/',
    //   name: 'businesspartner',
    //   component: () => import('./views/BusinessPartner.vue'),
    // },

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
    // login logoff redirects
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: () => import(/* webpackChunkName: "about" */ './views/Register.vue'),
    // },
    // {
    //   path: '/remember',
    //   name: 'remember',
    //   component: () => import(/* webpackChunkName: "about" */ './views/Remember.vue'),
    // },

    // {
    //   path: '/pset',
    //   name: 'pset',
    //   component: () => import('./views/Pset.vue'),
    //   props: true
    // },
    // {
    //   path: '/pset/:id',
    //   name: 'pset',
    //   component: () => import('./views/Pset.vue'),
    // },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/Dashboard.vue'),
    },

    {
      path: '/users',
      name: 'users',
      component: () => import('./views/Users.vue'),
    },
    {
      path: '/useredit',
      name: 'useredit',
      component: () => import('./views/Useredit.vue'),
      props: true
    },
    {
      path: '/useredit/:id',
      name: 'useredit',
      component: () => import('./views/Useredit.vue'),
    },
    // {
    //   path: '/useradmins',
    //   name: 'useradmins',
    //   component: () => import('./views/Useradmins.vue'),
    // },
    // {
    //   path: '/useradminedit',
    //   name: 'useradminedit',
    //   component: () => import('./views/Useradminedit.vue'),
    //   props: true
    // },
    // {
    //   path: '/useradminedit/:id',
    //   name: 'useradminedit',
    //   component: () => import('./views/Useradminedit.vue'),
    // },

    {
      path: '/usermyprofile',
      name: 'usermyprofile',
      component: () => import('./views/UserMyProfile.vue'),
    },

    // {
    //   path: '/invoiceinboundexport',
    //   name: 'invoiceinboundexport',
    //   component: () => import('./views/InvoicenInboundExport.vue'),
    // },


    //   {
    //     path: '/forgottenpassword',
    //     name: 'forgottenpassword',
    //     component: () => import(/* webpackChunkName: "about" */ './views/Forgottenpassword.vue'),
    //   },
    //   {
    //     path: '/dashboard',
    //     name: 'dashboard',
    //     component: () => import('./views/Dashboard.vue'),
    //   },
    //   // Selling
    //   {
    //     path: '/seldashboard',
    //     name: 'seldashboard',
    //     component: () => import('./views/SelDashboard.vue'),
    //   },
    //   {
    //     path: '/selcharts',
    //     name: 'selcharts',
    //     component: () => import('./views/SelCharts.vue'),
    //   },
    //   {
    //     path: '/selproducts',
    //     name: 'selproducts',
    //     component: () => import('./views/SelProducts.vue'),
    //   },
    //   {
    //     path: '/selproduct',
    //     name: 'selproduct',
    //     component: () => import('./views/SelProduct.vue'),
    //     props: true
    //   },
    //   {
    //     path: '/selproduct/:id',
    //     name: 'selproduct',
    //     component: () => import('./views/SelProduct.vue'),
    //   },
    //   {
    //     path: '/selproductcategories',
    //     name: 'selproductcategories',
    //     component: () => import('./views/SelProductCategories.vue'),
    //   },
    //   {
    //     path: '/selproductcategory',
    //     name: 'selproductcategory',
    //     component: () => import('./views/SelProductCategory.vue'),
    //     props: true
    //   },
    //   {
    //     path: '/selproductcategory/:id',
    //     name: 'selproductcategory',
    //     component: () => import('./views/SelProductCategory.vue'),
    //   },
    //
    //
    //   {
    //     path: '/selbuyers',
    //     name: 'selbuyers',
    //     component: () => import('./views/SelBuyers.vue'),
    //   },
    //   {
    //     path: '/selbuyeredit',
    //     name: 'selbuyeredit',
    //     component: () => import('./views/SelBuyerEdit.vue'),
    //     props: true
    //   },
    //   {
    //     path: '/selbuyeredit/:id',
    //     name: 'selbuyeredit',
    //     component: () => import('./views/SelBuyerEdit.vue'),
    //   },
    //
    //   {
    //     path: '/seldiscountchooses',
    //     name: 'seldiscountchooses',
    //     component: () => import('./views/SelDiscountChooses.vue'),
    //   },
    //   {
    //     path: '/seldiscountchoose',
    //     name: 'seldiscountchoose',
    //     component: () => import('./views/SelDiscountChoose.vue'),
    //     props: true
    //   },
    //   {
    //     path: '/seldiscountchoose/:id',
    //     name: 'seldiscountchoose',
    //     component: () => import('./views/SelDiscountChoose.vue'),
    //   },
    //   {
    //     path: '/selsells',
    //     name: 'selsells',
    //     component: () => import('./views/SelSells.vue'),
    //   },
    //   {
    //     path: '/selsellview/:id',
    //     name: 'selsellview',
    //     component: () => import('./views/SelSellView.vue'),
    //   },
    //
    //   {
    //     path: '/selstores',
    //     name: 'selstores',
    //     component: () => import('./views/SelStores.vue'),
    //   },
    //   {
    //     path: '/selstore',
    //     name: 'selstores',
    //     component: () => import('./views/SelStore.vue'),
    //     props: true
    //   },
    //   {
    //     path: '/selstore/:id',
    //     name: 'selstore',
    //     component: () => import('./views/SelStore.vue'),
    //   },
    //
    //   {
    //     path: '/stostockalerts',
    //     name: 'stostockalerts',
    //     component: () => import('./views/StoStockAlerts.vue'),
    //   },
    //   {
    //     path: '/worworklogs',
    //     name: 'worworklogs',
    //     component: () => import('./views/WorWorklogs.vue'),
    //   },
    //   {
    //     path: '/wordaylogs',
    //     name: 'wordaylogs',
    //     component: () => import('./views/WorDaylogs.vue'),
    //   },
    //
    //   {
    //     path: '/selworkstations',
    //     name: 'selworkstations',
    //     component: () => import('./views/SelWorkstations.vue'),
    //   },
    //   {
    //     path: '/selworkstation',
    //     name: 'selworkstation',
    //     component: () => import('./views/SelWorkstation.vue'),
    //     props: true
    //   },
    //   {
    //     path: '/selworkstation/:id',
    //     name: 'selworkstation',
    //     component: () => import('./views/SelWorkstation.vue'),
    //   },
    //   {
    //     path: '/selc',
    //     name: 'selc',
    //     component: () => import('./views/SelC.vue'),
    //   },
    //
    // // selsettings
    //   {
    //     path: '/selsettings',
    //     name: 'selsettings',
    //     component: () => import('./views/SelSettings.vue'),
    //   },
    //   // {
    //   //   path: '/selsetting',
    //   //   name: 'selsetting',
    //   //   component: () => import('./views/SelSetting.vue'),
    //   //   props: true
    //   // },
    //   // {
    //   //   path: '/selsetting/:id',
    //   //   name: 'selsetting',
    //   //   component: () => import('./views/SelSetting.vue'),
    //   // },
    //   // selscontents
    //   {
    //     path: '/selcontents',
    //     name: 'selcontents',
    //     component: () => import('./views/SelContents.vue'),
    //   },
    //   {
    //     path: '/selcontent',
    //     name: 'selcontent',
    //     component: () => import('./views/SelContent.vue'),
    //     props: true
    //   },
    //   {
    //     path: '/selcontent/:id',
    //     name: 'selcontent',
    //     component: () => import('./views/SelContent.vue'),
    //   },
    //
    //   // User and profile
    //   {
    //     path: '/usermyprofile',
    //     name: 'usermyprofile',
    //     component: () => import('./views/UserMyProfile.vue'),
    //   },
    //   {
    //     path: '/usersettings',
    //     name: 'usersettings',
    //     component: () => import('./views/UserSettings.vue'),
    //   },
    //   {
    //     path: '/users',
    //     name: 'users',
    //     component: () => import('./views/Users.vue'),
    //   },
    //   {
    //     path: '/useredit/:id',
    //     name: 'useredit',
    //     component: UserEdit,
    //     props: true ,
    //   },
    //   {
    //     path: '/useredit/',
    //     name: 'useredit',
    //     component: () => import('./views/UserEdit.vue'),
    //   },
    //
    //
    //   {
    //     path: '/cloudusers',
    //     name: 'cloudusers',
    //     component: () => import('./views/CloudUsers.vue'),
    //   },
    //   {
    //     path: '/clouduser/:id',
    //     name: 'clouduser',
    //     component: () => import('./views/CloudUser.vue'),
    //   },
    //   {
    //     path: '/clouduser/',
    //     name: 'clouduser',
    //     component: () => import('./views/CloudUser.vue'),
    //   },
    //
    //   {
    //     path: '/stodeliverynotes',
    //     name: 'stodeliverynotes',
    //     component: () => import('./views/StoDeliveryNotes.vue'),
    //   },
    //   {
    //     path: '/stodeliverynote/:id',
    //     name: 'stodeliverynote',
    //     component: () => import('./views/StoDeliveryNote.vue'),
    //   },
    //   {
    //     path: '/stodeliverynote/',
    //     name: 'stodeliverynote',
    //     component: () => import('./views/StoDeliveryNote.vue'),
    //   },
    //
    //
    //   {
    //     path: '/storevenue/',
    //     name: 'storevenue',
    //     component: () => import('./views/StoRevenue.vue'),
    //   },
    //   {
    //     path: '/storevenue/:id',
    //     name: 'storevenue',
    //     component: () => import('./views/StoRevenue.vue'),
    //   },
    //   {
    //     path: '/storevenues',
    //     name: 'storevenues',
    //     component: () => import('./views/StoRevenues.vue'),
    //   },


    //
    //    {
    //      path: '/stobuyerorders',
    //      name: 'stobuyerorders',
    //      component: () => import('./views/StoBuyerorders.vue'),
    //    },
    //    {
    //      path: '/stobuyerorder/:id',
    //      name: 'stobuyerorder',
    //      component: () => import('./views/StoBuyerorder.vue'),
    //    },
    //    {
    //      path: '/stobuyerorder/',
    //      name: 'stobuyerorder',
    //      component: () => import('./views/StoBuyerorder.vue'),
    //    },
    //
    //    {
    //      path: '/stoorders',
    //      name: 'stoorders',
    //      component: () => import('./views/StoOrders.vue'),
    //    },
    //    {
    //      path: '/stoorder/:id',
    //      name: 'stoorder',
    //      component: () => import('./views/StoOrder.vue'),
    //    },
    //    {
    //      path: '/stoorder/',
    //      name: 'stoorder',
    //      component: () => import('./views/StoOrder.vue'),
    //    },
    //
    //    {
    //      path: '/storevenues',
    //      name: 'storevenues',
    //      component: () => import('./views/StoRevenues.vue'),
    //    },
    //    {
    //      path: '/storevenue/:id',
    //      name: 'storevenue',
    //      component: () => import('./views/StoRevenue.vue'),
    //    },
    //    {
    //      path: '/storevenue/',
    //      name: 'storevenue',
    //      component: () => import('./views/StoRevenue.vue'),
    //    },
    //
    //
    //
    //    {
    //      path: '/invinvoices',
    //      name: 'invinvoices',
    //      component: () => import('./views/InvInvoices.vue'),
    //    },
    //    {
    //      path: '/invinvoice/:id',
    //      name: 'invinvoice',
    //      component: () => import('./views/InvInvoice.vue'),
    //    },
    //    {
    //      path: '/invinvoice/',
    //      name: 'invinvoice',
    //      component: () => import('./views/InvInvoice.vue'),
    //    },
    //
    //
    //
    //

    //
    // {
    //   path: '/crmbusinesspartners',
    //   name: 'crmbusinesspartner',
    //   component: () => import('./views/CrmBusinessPartners.vue'),
    // },
    // {
    //   path: '/crmbusinesspartner/:id',
    //   name: 'crmbusinesspartner',
    //   component: () => import('./views/CrmBusinessPartner.vue'),
    // },
    // {
    //   path: '/crmbusinesspartner/',
    //   name: 'crmbusinesspartner',
    //   component: () => import('./views/CrmBusinessPartner.vue'),
    // },
    // {
    //   path: '/companydata/',
    //   name: 'companydata',
    //   component: () => import('./views/CompanyData.vue'),
    // },
    // {
    //   path: '/crmcontacts',
    //   name: 'crmcontacts',
    //   component: () => import('./views/CrmContacts.vue'),
    // },
    // {
    //   path: '/crmcontact/:id',
    //   name: 'crmcontact',
    //   component: () => import('./views/CrmContact.vue'),
    // },
    // {
    //   path: '/crmcontact/',
    //   name: 'crmcontact',
    //   component: () => import('./views/CrmContact.vue'),
    // },
    // {
    //   path: '/crmcontact/',
    //   name: 'crmcontactParams',
    //   props: true,
    //   component: () => import('./views/CrmContact.vue'),
    // },
    // {
    //   path: '/crmaddress/:id',
    //   name: 'crmaddress',
    //   props: true,
    //   component: () => import('./views/CrmAddress.vue'),
    // },
    // {
    //   path: '/crmaddress/',
    //   name: 'crmaddress',
    //   props: true,
    //   component: () => import('./views/CrmAddress.vue'),
    // },
    // {
    //   path: '/crmaddress/',
    //   name: 'crmaddressParams',
    //   props: true,
    //   component: () => import('./views/CrmAddress.vue'),
    // },
    //
    //
    // {
    //   path: '/offoffers',
    //   name: 'offoffers',
    //   component: () => import('./views/OffOffers.vue'),
    // },
    // {
    //   path: '/offoffer/:id',
    //   name: 'offoffer',
    //   props: true,
    //   component: () => import('./views/OffOffer.vue'),
    // },
    // {
    //   path: '/offoffer/',
    //   name: 'offoffer',
    //   props: true,
    //   component: () => import('./views/OffOffer.vue'),
    // },
    // {
    //   path: '/selvats',
    //   name: 'selvats',
    //   component: () => import('./views/SelVats.vue'),
    // },
    // {
    //   path: '/selvat/:id',
    //   name: 'selvat',
    //   props: true,
    //   component: () => import('./views/SelVat.vue'),
    // },
    // {
    //   path: '/selvat/',
    //   name: 'selvat',
    //   props: true,
    //   component: () => import('./views/SelVat.vue'),
    // },

  ],
});
